// In this file we provide access to public modules, such as sign up, sign in, landing page, FAQ etc.

// Note that here we don't use any lazy loading (as compared to private modules),
// because it doesn't really make sense to make the auth part of the app be missing in the starting bundle

import { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { OpenLayout } from "../../components/open-layout/OpenLayout";
import { SuspenseLoader } from "../../components/suspense-loader/SuspenseLoader";
import ResetPasswordModule from "./reset-password-module";
import AcceptInvite from "./accept-invite";
import PageNotFound from "../../components/page-not-found";

const SignInModule = lazy(async () => await import("./signin-module"));
const RedirectsModule = lazy(async () => await import("./redirects-module"));
const FirebaseEmailVerification = lazy(
  async () => await import("./firebase-email-verification")
);

const OpenModule = () => {
  return (
    <Routes>
      <Route path="/" element={<OpenLayout />}>
        <Route
          path="redirects/*"
          element={
            <SuspenseLoader>
              <RedirectsModule />
            </SuspenseLoader>
          }
        />
        <Route
          path="sign-in/*"
          element={
            <SuspenseLoader>
              <SignInModule />
            </SuspenseLoader>
          }
        />
      </Route>
      <Route
        path="reset-password/*"
        element={
          <SuspenseLoader>
            <ResetPasswordModule />
          </SuspenseLoader>
        }
      />
      <Route
        path="accept-invite/*"
        element={
          <SuspenseLoader>
            <AcceptInvite />
          </SuspenseLoader>
        }
      />
      <Route
        path="firebase-email-verification"
        element={
          <SuspenseLoader>
            <FirebaseEmailVerification />
          </SuspenseLoader>
        }
      />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default OpenModule;
